document.addEventListener('DOMContentLoaded', function() {
  (function($) {
    $('.mobile-slide__toggle_link a').click(function(e){
      e.preventDefault();
      $(this).parents('.mobile-details').find('.accordion-list').toggleClass('active');
    })
    $(".pcc-slider").each(function() {
      var hammerClass = new Hammer(this);
      hammerClass.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL });
      hammerClass.on('swipe', handleSwipe);

      var that = $(this);
      var slides = that.find('.pcc-slider__slide:not(.skip_img)');
      var card_slider = that.find('.card-partial__col');

      var minHeight = 0;
      slides.each(function() {
        var image = $(this).children();
        var card_col = $(this).find('.card-partial__col');
        if(card_col){
          var height = $(card_col).outerHeight();
          if(minHeight < height){
            minHeight = height + 50;
          }
        }
        if (image[0].tagName == "IMG") image.replaceWith(turnToDiv(image[0]));
      });
      var divs = slides.children('div');
      var leftPercentage = 0;
      if(card_slider && card_slider.length){
        var slides = $(this).find('.pcc-slider__slide');
        $(this).css('height', minHeight);
        $(slides).css('height', minHeight);
        $('.packages-mobile-slides__container').css('height', minHeight);
      }
      divs.each(function() {
        that = $(this);
        if (that.attr("src")) that.css("background-image", 'url("' + that.attr("src") + '")');
        that.parent().css("left", leftPercentage + "%")
        that.removeAttr("src");
        leftPercentage += 83;
      });
    });

    function handleSwipe(e) {
      if (window.innerWidth > 639) return;
      var that = $(e.target);
      var slider = (that.hasClass('pcc-slider') ? that.find('.pcc-slider__container ul') : that.parents('.pcc-slider').find('.pcc-slider__container ul'));
      var container;
      switch (e.direction) {
        case 2:
          var slidePosition = slider[0].style.left ? parseInt(slider[0].style.left) : slider[0].style.left = "0";
          slidePosition -= 83;
          pcc_slide_animate(slidePosition);
        break;
        case 4:
          var slidePosition = parseInt(slider[0].style.left);
          slidePosition += 83;
          pcc_slide_animate(slidePosition);
        break;
        default:
          return;
        break;
      }

      function pcc_slide_animate(leftValue) {
        if (-leftValue/83 == slider.eq(0).children().length) {
          leftValue = 0;
        } else if (-leftValue/83 < 0) {
          leftValue = -(83 * (slider.eq(0).children().length - 1));
        }
        slider.eq(0).css("left", leftValue + "%");
      }
    }

    function turnToDiv(elem) {
      var newElem = document.createElement('div'),
          i,
          prop,
          attr = elem.attributes,
          attrLen = attr.length;

      elem = elem.cloneNode(true);
      while (elem.firstChild) {
        newElem.appendChild(elem.firstChild);
      }

      for (i in elem) {
        try {
          prop = elem[i];
          if (prop && i !== 'outerHTML' && (typeof prop === 'string' || typeof prop === 'number')) {
            newElem[i] = elem[i];
          }
        }
        catch(err) {}

        for (i = 0; i < attrLen; i++) {
          newElem.setAttribute(attr[i].nodeName, attr[i].nodeValue);
        }

        newElem.style.cssText = elem.style.cssText;
        return newElem;
      }
    }

    $('#ti_package_options .package-content__container').slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      dot: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 600,
          settings: "unslick"
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });


    $(window).resize(function(){
      if (window.innerWidth > 639) return;
        $(".pcc-slider").each(function() {
  
            var card_slider = $(this).find('.card-partial__col');
            if(card_slider && card_slider.length){
              console.log('card_slider',card_slider);
              var slides = $(this).find('.pcc-slider__slide');
              var minHeight = 0;
              $(this).css('height', minHeight);
              $(slides).css('height', minHeight);
              $('.packages-mobile-slides__container').css('height', minHeight);
              slides.each(function() {
                var card_col = $(this).find('.card-partial__col');
                if(card_col){
                  var height = $(card_col).outerHeight();
                  if(minHeight < height){
                    minHeight = height + 50;
                  }
                }
              });
              $(this).css('height', minHeight);
              $(slides).css('height', minHeight);
              $('.packages-mobile-slides__container').css('height', minHeight);
            }
        });
    });
  })(jQuery);
});
